import { Link, P, Table, Td, Th, Tr } from '@dnb/eufemia';
import { Link as RouterLink } from 'react-router-dom';

import { useBackend } from '@/hooks/useBackend';

interface Props {
  scopeName: string;
}

interface App {
  id: string;
  name: string;
  description: string | null;
  environmentAccess: 'TEST' | 'LIVE';
  serviceNowIdentifier: string | null;
}

export function AppsWithScope({ scopeName }: Props) {
  const { data: apps } = useBackend('/scopes/{scopeName}/apps', { params: { path: { scopeName } } });

  if (!apps || apps?.length === 0) {
    return <P top="large">No app found with access to this scope</P>;
  }

  // Group apps by ID and collect environments
  const groupedApps = Object.values(
    apps.reduce(
      (acc, app) => {
        if (!acc[app.id]) {
          acc[app.id] = {
            ...app,
            environments: [app.environmentAccess],
          };
        } else if (!acc[app.id]!.environments.includes(app.environmentAccess)) {
          acc[app.id]!.environments.push(app.environmentAccess);
        }
        return acc;
      },
      {} as Record<string, App & { environments: ('TEST' | 'LIVE')[] }>,
    ),
  );

  return (
    <Table>
      <thead>
        <Tr>
          <Th>Name</Th>
          <Th>Environment</Th>
        </Tr>
      </thead>
      <tbody>
        {groupedApps.map((app) => (
          <Tr key={app.id}>
            <Td>
              <Link element={RouterLink} to={`/apps/${app.id}`}>
                <span style={{ wordBreak: 'break-word' }}>{app.name}</span>
              </Link>
            </Td>
            <Td>{app.environments.join(', ')}</Td>
          </Tr>
        ))}
      </tbody>
    </Table>
  );
}
